import { RouteRecordRaw } from 'vue-router'

export interface ServiceConfig {
  name: string;
  label: string;
  path: string;
  route: string;
  component: () => Promise<any>;
  meta: {
    title: string;
    subtitle: string;
    description: string;
  };
}

export const SERVICES: ServiceConfig[] = [
  {
    name: 'mufflers',
    label: 'Mufflers',
    path: '/services/muffler-services',
    route: 'muffler-services',
    component: () => import('@/features/services/MufflerService.vue'),
    meta: {
      title: 'Muffler Repair & Custom Exhaust Systems | Plaza Muffler & Hitch',
      subtitle: 'Professional exhaust repair and custom performance solutions',
      description: 'Expert muffler repair, performance exhaust systems, and custom fabrication. Same-day service, trusted installations.'
    }
  },
  {
    name: 'catalytic',
    label: 'Catalytic Converters',
    path: '/services/catalytic-converters',
    route: 'catalytic-service',
    component: () => import('@/features/services/CatalyticService.vue'),
    meta: {
      title: 'Catalytic Converter Replacement & Repair | Plaza Muffler & Hitch',
      subtitle: 'EPA-certified catalytic converter solutions and emissions repair',
      description: 'Professional catalytic converter replacement and repair. EPA-compliant parts, check engine light diagnostics, emissions testing solutions.'
    }
  },
  {
    name: 'hitches',
    label: 'Trailer Hitches',
    path: '/services/trailer-hitches',
    route: 'trailer-hitches',
    component: () => import('@/features/services/HitchService.vue'),
    meta: {
      title: 'Trailer Hitch Installation & Towing Accessories | Plaza Muffler & Hitch',
      subtitle: 'Professional trailer hitch installation and wiring services',
      description: 'Expert trailer hitch installation, wiring harness setup, and towing accessories. All major brands, same-day installation available.'
    }
  },
  {
    name: 'welding',
    label: 'Welding',
    path: '/services/welding-services',
    route: 'welding-services',
    component: () => import('@/features/services/WeldingService.vue'),
    meta: {
      title: 'Custom Welding & Fabrication Services | Plaza Muffler & Hitch',
      subtitle: 'Professional metal fabrication and custom exhaust solutions',
      description: 'Expert welding services, custom exhaust fabrication, and metal repairs. Certified welders, precision work, quick turnaround.'
    }
  }
];

// Helper functions
export const getServiceNames = (): string[] => SERVICES.map(service => service.name);
export const getServiceByName = (name: string): ServiceConfig | undefined => 
  SERVICES.find(service => service.name === name);

// Generate route configurations
export const generateServiceRoutes = (): RouteRecordRaw[] => 
  SERVICES.map(service => ({
    path: service.path.slice(1), // Remove leading slash
    name: service.route,
    component: service.component,
    meta: service.meta
  }));

// Generate navigation items
export const generateServiceNavItems = () => 
  SERVICES.map(({ name, label, path }) => ({
    name,
    label,
    to: path
  }));